require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/es7.symbol.observable.js
// module id = 743
// module chunks = 0